<template>
  <db-icon
    id="info"
    icon="info"
    icon-custom
    variant=""
    style="
      --icon-font-size: 6rem;
      --icon-font-family: 'icons-32-outline';
      color: #616161;
      --icon-font-weight: 400;
    "
    class="hydrated"
  ></db-icon>
</template>
